module.exports = __webpack_public_path__ + "static/media/user-banner.6779b407.png";